/* eslint-disable no-case-declarations */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import moment from 'moment';
import INITIAL_STATE from './initial_state';
import { ManagementState, ManagementTypes } from './types';

const reducer: Reducer<ManagementState> = (
  state = INITIAL_STATE,
  {
    type,
    result,
    selected_feature,
    selected_order,
    taskCommentId,
    taskId,
    biddingAttachmentId,
    biddingId,
    progressId,
    notificationProgressId,
    fileName,
    finishedManagementStatus,
    amount,
    comments,
    contact_client_id,
    biddings,
    statusChange,
    deadline,
    responsible,
    companyId,
  },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case ManagementTypes.GET_SUMMARY_REQUEST:
        draft.request.management_summary = {
          ...INITIAL_STATE.request.management_summary,
          loading: true,
        };
        break;

      case ManagementTypes.GET_SUMMARY_SUCCESS:
        draft.request.management_summary = {
          ...INITIAL_STATE.request.management_summary,
          loaded: true,
        };
        draft.management.management_summary = {
          total_favorites: result.data.total_favorites,
          total_managed: result.data.total_managed,
          total_finished: {
            winner: result.data.total_finished.winner,
            partial_winner: result.data.total_finished.partial_winner,
            lost: result.data.total_finished.lost,
            declined: result.data.total_finished.declined,
            revoked: result.data.total_finished.revoked,
            failed: result.data.total_finished.failed,
            cancelled: result.data.total_finished.cancelled,
          },
          total_tasks: {
            late: result.data.total_tasks.late,
            today: result.data.total_tasks.today,
            future: result.data.total_tasks.future,
            finished: result.data.total_tasks.finished,
          },
          total_progress: {
            read: result.data.total_progress.read,
            unread: result.data.total_progress.unread,
          },
        };
        break;

      case ManagementTypes.GET_SUMMARY_FAILURE:
        draft.request.management_summary = {
          ...INITIAL_STATE.request.management_summary,
          error: true,
        };
        break;
      case ManagementTypes.GET_BIDDING_SUMMARY_REQUEST:
        draft.request.bidding_summary = {
          ...INITIAL_STATE.request.bidding_summary,
          loading: true,
        };
        break;

      case ManagementTypes.GET_BIDDING_SUMMARY_SUCCESS:
        draft.request.bidding_summary = {
          ...INITIAL_STATE.request.bidding_summary,
          loaded: true,
        };
        draft.management.bidding_summary[biddingId] = result.data;

        break;

      case ManagementTypes.GET_BIDDING_SUMMARY_FAILURE:
        draft.request.bidding_summary = {
          ...INITIAL_STATE.request.bidding_summary,
          error: true,
        };
        break;

      case ManagementTypes.GET_CALENDAR_EVENTS_REQUEST:
        draft.request.calendar_events = {
          ...INITIAL_STATE.request.calendar_events,
          loading: true,
        };
        break;

      case ManagementTypes.GET_CALENDAR_EVENTS_SUCCESS:
        draft.request.calendar_events = {
          ...INITIAL_STATE.request.calendar_events,
          loaded: true,
        };
        draft.management.calendar_events = result.data.events ?? [];
        break;

      case ManagementTypes.GET_CALENDAR_EVENTS_FAILURE:
        draft.request.calendar_events = {
          ...INITIAL_STATE.request.calendar_events,
          error: true,
        };
        break;

      case ManagementTypes.GET_MANAGED_REQUEST:
        draft.request.managed = {
          ...INITIAL_STATE.request.managed,
          loading: true,
        };
        break;

      case ManagementTypes.GET_MANAGED_SUCCESS:
        draft.request.managed = {
          ...INITIAL_STATE.request.managed,
          loaded: true,
        };
        draft.management.managed = result.data.managed;
        draft.management.managed_total_entries =
          result.data.total_entries ?? result.data.managed?.length ?? 0;
        break;

      case ManagementTypes.GET_MANAGED_FAILURE:
        draft.request.managed = {
          ...INITIAL_STATE.request.managed,
          error: true,
        };
        break;

      case ManagementTypes.GET_TASKS_REQUEST:
        draft.request.get_tasks = {
          ...INITIAL_STATE.request.get_tasks,
          loading: true,
        };
        break;

      case ManagementTypes.GET_TASKS_SUCCESS:
        draft.request.get_tasks = {
          ...INITIAL_STATE.request.get_tasks,
          loaded: true,
        };

        // Visão de detalhe (getTasks com biddingId) escreve num slice próprio,
        // para não sobrescrever a lista geral da aba Gerenciar > Tarefas.
        if (biddingId) {
          draft.management.bidding_tasks = result.data.tasks;
          draft.management.bidding_tasks_total_entries =
            result.data.total_entries ?? result.data.tasks?.length ?? 0;
        } else {
          draft.management.tasks = result.data.tasks;
          draft.management.tasks_total_entries =
            result.data.total_entries ?? result.data.tasks?.length ?? 0;
        }
        break;

      case ManagementTypes.GET_TASKS_FAILURE:
        draft.request.get_tasks = {
          ...INITIAL_STATE.request.get_tasks,
          error: true,
        };
        break;

      case ManagementTypes.GET_BIDDING_TIMELINE_REQUEST:
        draft.request.get_bidding_timeline = {
          ...INITIAL_STATE.request.get_bidding_timeline,
          loading: true,
        };
        break;

      case ManagementTypes.GET_BIDDING_TIMELINE_SUCCESS:
        draft.request.get_bidding_timeline = {
          ...INITIAL_STATE.request.get_bidding_timeline,
          loaded: true,
        };
        draft.management.timeline_tasks = result.data.tasks ?? [];
        draft.management.timeline_progress = result.data.progress_notifications ?? [];
        break;

      case ManagementTypes.GET_BIDDING_TIMELINE_FAILURE:
        draft.request.get_bidding_timeline = {
          ...INITIAL_STATE.request.get_bidding_timeline,
          error: true,
        };
        break;

      case ManagementTypes.GET_TASK_BY_ID_REQUEST:
        draft.request.get_task_by_id = {
          ...INITIAL_STATE.request.get_task_by_id,
          loading: true,
        };
        break;

      case ManagementTypes.GET_TASK_BY_ID_SUCCESS:
        draft.request.get_task_by_id = {
          ...INITIAL_STATE.request.get_task_by_id,
          loaded: true,
        };
        draft.management.modal_task = result.data.task ?? null;
        break;

      case ManagementTypes.GET_TASK_BY_ID_FAILURE:
        draft.request.get_task_by_id = {
          ...INITIAL_STATE.request.get_task_by_id,
          error: true,
        };
        draft.management.modal_task = null;
        break;

      case ManagementTypes.CLEAR_MODAL_TASK:
        draft.management.modal_task = null;
        draft.request.get_task_by_id = INITIAL_STATE.request.get_task_by_id;
        break;

      case ManagementTypes.CREATE_MANAGED_REQUEST:
        draft.request.managed = {
          ...INITIAL_STATE.request.managed,
          loading: true,
        };
        break;

      case ManagementTypes.CREATE_MANAGED_SUCCESS:
        draft.request.managed = {
          ...INITIAL_STATE.request.managed,
          loaded: true,
        };

        const managedIndex = state.management.managed.findIndex(
          (managed) => managed.id === biddingId,
        );

        if (managedIndex !== -1) {
          draft.management.managed[managedIndex] = result.data.managed;
        } else {
          draft.management.managed.push(result.data.managed);
        }

        break;

      case ManagementTypes.CREATE_MANAGED_FAILURE:
        draft.request.managed = {
          ...INITIAL_STATE.request.managed,
          error: true,
        };
        break;

      case ManagementTypes.DELETE_MANAGED_REQUEST:
        draft.request.managed = {
          ...INITIAL_STATE.request.managed,
          loading: true,
        };
        break;

      case ManagementTypes.DELETE_MANAGED_SUCCESS:
        draft.request.managed = {
          ...INITIAL_STATE.request.managed,
          loaded: true,
        };

        const managedDeleteIndex = state.management.managed.findIndex(
          (managed) => managed.id === biddingId,
        );

        // Em telas onde a lista paginada não está carregada (ex.: detalhes da licitação),
        // o item pode não estar em management.managed — nesse caso não há slice para
        // atualizar e o resumo é recarregado pelo componente.
        if (managedDeleteIndex !== -1) {
          const bidding = draft.management.managed[managedDeleteIndex];

          bidding.managers = bidding.managers.filter(
            (manager) => manager.user_id !== contact_client_id,
          );

          if (bidding.managers.length > 0) {
            bidding.managed = false;
          } else {
            draft.management.managed.splice(managedDeleteIndex, 1);
          }
        }

        break;

      case ManagementTypes.DELETE_MANAGED_FAILURE:
        draft.request.managed = {
          ...INITIAL_STATE.request.managed,
          error: true,
        };
        break;

      case ManagementTypes.DELETE_MANAGED_BATCH_REQUEST:
        draft.request.managed = {
          ...INITIAL_STATE.request.managed,
          loading: true,
        };
        break;

      case ManagementTypes.DELETE_MANAGED_BATCH_SUCCESS: {
        draft.request.managed = {
          ...INITIAL_STATE.request.managed,
          loaded: true,
        };

        const removedIds: Array<number> = result?.data?.removed_bidding_ids || [];
        draft.management.managed = draft.management.managed.filter(
          (managed) => !removedIds.includes(managed.id),
        );
        draft.management.finished = draft.management.finished.filter(
          (finished) => !removedIds.includes(finished.id),
        );
        break;
      }

      case ManagementTypes.DELETE_MANAGED_BATCH_FAILURE:
        draft.request.managed = {
          ...INITIAL_STATE.request.managed,
          error: true,
        };
        break;

      case ManagementTypes.REACTIVATE_MANAGED_BATCH_REQUEST:
        draft.request.finished = {
          ...INITIAL_STATE.request.finished,
          loading: true,
        };
        break;

      case ManagementTypes.REACTIVATE_MANAGED_BATCH_SUCCESS:
        draft.request.finished = {
          ...INITIAL_STATE.request.finished,
          loaded: true,
        };

        const reactivatedIds: Array<number> = result?.data?.reactivated_bidding_ids || [];
        draft.management.finished = draft.management.finished.filter(
          (finished) => !reactivatedIds.includes(finished.id),
        );
        break;

      case ManagementTypes.REACTIVATE_MANAGED_BATCH_FAILURE:
        draft.request.finished = {
          ...INITIAL_STATE.request.finished,
          error: true,
        };
        break;

      case ManagementTypes.FINISH_MANAGED_BATCH_REQUEST:
        draft.request.finish_managed_batch = {
          ...INITIAL_STATE.request.finish_managed_batch,
          loading: true,
        };
        break;

      case ManagementTypes.FINISH_MANAGED_BATCH_SUCCESS: {
        draft.request.finish_managed_batch = {
          ...INITIAL_STATE.request.finish_managed_batch,
          loaded: true,
        };

        const finishedIds: Array<number> = result?.data?.finished_bidding_ids || [];
        const finishedAt =
          result?.data?.finished_at || moment().format('YYYY-MM-DDTHH:mm:ss.SSSSZ');
        const amountsByBid: Record<number, string | undefined> = {};
        if (Array.isArray(biddings)) {
          biddings.forEach((b: { id: number; amount?: string }) => {
            amountsByBid[b.id] = b.amount;
          });
        }

        const finishedFromManaged = state.management.managed.filter((m) =>
          finishedIds.includes(m.id),
        );

        draft.management.finished = [
          ...state.management.finished,
          ...finishedFromManaged.map((m) => ({
            ...m,
            management_bidding_finished: {
              amount: Number(amountsByBid[m.id] || 0),
              created_at: finishedAt,
              comments,
            },
            management_finished_status: finishedManagementStatus,
          })),
        ];

        draft.management.managed = state.management.managed.filter(
          (m) => !finishedIds.includes(m.id),
        );

        draft.management.tasks = state.management.tasks.map((task) =>
          finishedIds.includes(task.bidding_id) && task.status_task_id === 'in_progress'
            ? { ...task, status_task_id: 'finished' }
            : task,
        );
        break;
      }

      case ManagementTypes.FINISH_MANAGED_BATCH_FAILURE:
        draft.request.finish_managed_batch = {
          ...INITIAL_STATE.request.finish_managed_batch,
          error: true,
        };
        break;

      case ManagementTypes.UPDATE_TASKS_STATUS_BATCH_REQUEST:
        draft.request.update_tasks_status_batch = {
          ...INITIAL_STATE.request.update_tasks_status_batch,
          loading: true,
        };
        break;

      case ManagementTypes.UPDATE_TASKS_STATUS_BATCH_SUCCESS: {
        draft.request.update_tasks_status_batch = {
          ...INITIAL_STATE.request.update_tasks_status_batch,
          loaded: true,
        };

        const updatedTaskIds: Array<number> = result?.data?.updated_task_ids || [];
        const updatedAt = result?.data?.updated_at;

        draft.management.tasks = state.management.tasks.map((task) => {
          if (!updatedTaskIds.includes(task.id)) return task;
          let nextStatus = task.status_task_id;
          let nextFinishedDate = task.finished_date;
          if (statusChange === 'finished') {
            nextStatus = 'finished';
            nextFinishedDate = updatedAt;
          } else if (statusChange === 'in_progress') {
            nextStatus = 'in_progress';
            nextFinishedDate = null;
          }
          return {
            ...task,
            status_task_id: nextStatus,
            finished_date: nextFinishedDate,
            deadline: deadline || task.deadline,
            ...(responsible
              ? {
                  responsible_id: responsible.id,
                  responsible: { id: responsible.id, nome: responsible.nome },
                }
              : {}),
          };
        });
        break;
      }

      case ManagementTypes.UPDATE_TASKS_STATUS_BATCH_FAILURE:
        draft.request.update_tasks_status_batch = {
          ...INITIAL_STATE.request.update_tasks_status_batch,
          error: true,
        };
        break;

      case ManagementTypes.MARK_READ_PROGRESS_BATCH_REQUEST:
        draft.request.mark_read_progress_batch = {
          ...INITIAL_STATE.request.mark_read_progress_batch,
          loading: true,
        };
        break;

      case ManagementTypes.MARK_READ_PROGRESS_BATCH_SUCCESS: {
        draft.request.mark_read_progress_batch = {
          ...INITIAL_STATE.request.mark_read_progress_batch,
          loaded: true,
        };

        const readNotificationIds: Array<number> =
          result?.data?.read_notification_progress_ids || [];
        draft.management.notification_progress = state.management.notification_progress.map(
          (notif) => (readNotificationIds.includes(notif.id) ? { ...notif, read: true } : notif),
        );
        break;
      }

      case ManagementTypes.MARK_READ_PROGRESS_BATCH_FAILURE:
        draft.request.mark_read_progress_batch = {
          ...INITIAL_STATE.request.mark_read_progress_batch,
          error: true,
        };
        break;

      case ManagementTypes.MARK_UNREAD_PROGRESS_BATCH_REQUEST:
        draft.request.mark_unread_progress_batch = {
          ...INITIAL_STATE.request.mark_unread_progress_batch,
          loading: true,
        };
        break;

      case ManagementTypes.MARK_UNREAD_PROGRESS_BATCH_SUCCESS: {
        draft.request.mark_unread_progress_batch = {
          ...INITIAL_STATE.request.mark_unread_progress_batch,
          loaded: true,
        };

        const unreadNotificationIds: Array<number> =
          result?.data?.unread_notification_progress_ids || [];
        draft.management.notification_progress = state.management.notification_progress.map(
          (notif) => (unreadNotificationIds.includes(notif.id) ? { ...notif, read: false } : notif),
        );
        break;
      }

      case ManagementTypes.MARK_UNREAD_PROGRESS_BATCH_FAILURE:
        draft.request.mark_unread_progress_batch = {
          ...INITIAL_STATE.request.mark_unread_progress_batch,
          error: true,
        };
        break;

      case ManagementTypes.DELETE_TASKS_BATCH_REQUEST:
        draft.request.delete_task = {
          ...INITIAL_STATE.request.delete_task,
          loading: true,
        };
        break;

      case ManagementTypes.DELETE_TASKS_BATCH_SUCCESS:
        draft.request.delete_task = {
          ...INITIAL_STATE.request.delete_task,
          loaded: true,
        };

        const removedTaskIds: Array<number> = result?.data?.removed_task_ids || [];
        draft.management.tasks = draft.management.tasks.filter(
          (task) => !removedTaskIds.includes(task.id),
        );
        break;

      case ManagementTypes.DELETE_TASKS_BATCH_FAILURE:
        draft.request.delete_task = {
          ...INITIAL_STATE.request.delete_task,
          error: true,
        };
        break;

      case ManagementTypes.DELETE_PROGRESS_BATCH_REQUEST:
        draft.request.delete_progress = {
          ...INITIAL_STATE.request.delete_progress,
          loading: true,
        };
        break;

      case ManagementTypes.DELETE_PROGRESS_BATCH_SUCCESS:
        draft.request.delete_progress = {
          ...INITIAL_STATE.request.delete_progress,
          loaded: true,
        };

        const removedNotificationIds: Array<number> = result?.data?.removed_notification_ids || [];
        draft.management.notification_progress = draft.management.notification_progress.filter(
          (notif) => !removedNotificationIds.includes(notif.id),
        );
        break;

      case ManagementTypes.DELETE_PROGRESS_BATCH_FAILURE:
        draft.request.delete_progress = {
          ...INITIAL_STATE.request.delete_progress,
          error: true,
        };
        break;

      case ManagementTypes.CREATE_TASKS_REQUEST:
        draft.request.create_tasks = {
          ...INITIAL_STATE.request.create_tasks,
          loading: true,
        };
        break;

      case ManagementTypes.CREATE_TASKS_SUCCESS:
        draft.request.create_tasks = {
          ...INITIAL_STATE.request.create_tasks,
          loaded: true,
        };
        draft.management.tasks = [...draft.management.tasks, result.data.task];
        break;

      case ManagementTypes.CREATE_TASKS_FAILURE:
        draft.request.create_tasks = {
          ...INITIAL_STATE.request.create_tasks,
          error: true,
        };
        break;

      case ManagementTypes.UPDATE_TASKS_REQUEST:
        draft.request.update_tasks = {
          ...INITIAL_STATE.request.update_tasks,
          loading: true,
        };
        break;

      case ManagementTypes.UPDATE_TASKS_SUCCESS:
        draft.request.update_tasks = {
          ...INITIAL_STATE.request.update_tasks,
          loaded: true,
        };
        const tasksList = [...state.management.tasks];
        const taskIndex = state.management.tasks.findIndex(
          (task) => task.id === result.data.task.id,
        );
        // Guard: task pode não estar nesta página paginada (ex.: modal aberto via
        // getTaskById no calendário sobre task fora da página corrente). Atribuir
        // em índice -1 cria entrada negativa no array.
        if (taskIndex !== -1) {
          tasksList[taskIndex] = result.data.task;
          draft.management.tasks = tasksList;
        }
        break;

      case ManagementTypes.UPDATE_TASKS_FAILURE:
        draft.request.update_tasks = {
          ...INITIAL_STATE.request.update_tasks,
          error: true,
        };
        break;

      case ManagementTypes.DELETE_TASK_REQUEST:
        draft.request.delete_task = {
          ...INITIAL_STATE.request.delete_task,
          loading: true,
        };
        break;

      case ManagementTypes.DELETE_TASK_SUCCESS:
        draft.request.delete_task = {
          ...INITIAL_STATE.request.delete_task,
          loaded: true,
        };

        draft.management.tasks = state.management.tasks.filter((task) => task.id !== taskId);
        break;

      case ManagementTypes.DELETE_TASK_FAILURE:
        draft.request.delete_task = {
          ...INITIAL_STATE.request.delete_task,
          error: true,
        };
        break;

      case ManagementTypes.UPDATE_SELECTED_FEATURE:
        draft.management.selected_feature = selected_feature;
        break;

      case ManagementTypes.HANDLE_FILTER_BY:
        if (state.management.filtered_by === 'contact_client')
          draft.management.filtered_by = 'client';
        if (state.management.filtered_by === 'client')
          draft.management.filtered_by = 'contact_client';

        break;

      case ManagementTypes.HANDLE_ORDER:
        if (state.management.ordered_by === selected_order) {
          draft.management.order_direction =
            state.management.order_direction === 'asc' ? 'desc' : 'asc';
        } else {
          draft.management.ordered_by = selected_order;
          draft.management.order_direction = 'desc';
        }
        break;

      case ManagementTypes.DELETE_TASK_COMMENT_REQUEST:
        draft.request.delete_task_comment = {
          ...INITIAL_STATE.request.delete_task_comment,
          loading: true,
        };
        break;

      case ManagementTypes.DELETE_TASK_COMMENT_SUCCESS:
        draft.request.delete_task_comment = {
          ...INITIAL_STATE.request.delete_task_comment,
          loaded: true,
        };

        const deletedCommentTaskIndex = state.management.tasks.findIndex(
          (task) => task.id === taskId,
        );

        // Mesmo guard do CREATE_TASK_COMMENT_SUCCESS: com paginação server-side,
        // a task pode não estar carregada na página atual; sem o guard,
        // updatedCommentsTaskList[-1] cria entry negativa silenciosa no array
        // ou crasha em .task_event_comments.filter.
        if (deletedCommentTaskIndex !== -1) {
          const updatedCommentsTaskList = [...state.management.tasks];

          const currentTask = {
            ...updatedCommentsTaskList[deletedCommentTaskIndex],
          };

          const currentTaskComments = currentTask.task_event_comments.filter(
            (comment) => comment.id !== taskCommentId,
          );
          currentTask.task_event_comments = currentTaskComments;
          updatedCommentsTaskList[deletedCommentTaskIndex] = currentTask;
          draft.management.tasks = updatedCommentsTaskList;
        }
        break;

      case ManagementTypes.DELETE_TASK_COMMENT_FAILURE:
        draft.request.delete_task_comment = {
          ...INITIAL_STATE.request.delete_task_comment,
          error: true,
        };
        break;

      case ManagementTypes.CREATE_TASK_COMMENT_REQUEST:
        draft.request.create_task_comment = {
          ...INITIAL_STATE.request.create_task_comment,
          loading: true,
        };
        break;

      case ManagementTypes.CREATE_TASK_COMMENT_SUCCESS:
        draft.request.create_task_comment = {
          ...INITIAL_STATE.request.create_task_comment,
          loaded: true,
        };

        const createCommentTaskIndex = state.management.tasks.findIndex(
          (task) => task.id === taskId,
        );

        // Com paginação server-side, a task pode não estar carregada nesta página.
        // Sem o guard, draft.management.tasks[-1].task_event_comments = ... crasha.
        if (createCommentTaskIndex !== -1) {
          draft.management.tasks[createCommentTaskIndex].task_event_comments = [
            ...draft.management.tasks[createCommentTaskIndex].task_event_comments,
            result.data,
          ];
        }

        break;
      case ManagementTypes.CREATE_TASK_COMMENT_FAILURE:
        draft.request.create_task_comment = {
          ...INITIAL_STATE.request.create_task_comment,
          error: true,
        };
        break;
      case ManagementTypes.CREATE_PROGRESS_COMMENT_REQUEST:
        draft.request.create_progress_comment = {
          ...INITIAL_STATE.request.create_progress_comment,
          loading: true,
        };
        break;

      case ManagementTypes.CREATE_PROGRESS_COMMENT_SUCCESS:
        draft.request.create_progress_comment = {
          ...INITIAL_STATE.request.create_progress_comment,
          loaded: true,
        };

        const updatedNotificationProgressIndex = state.management.notification_progress.findIndex(
          (notification_progress) => notification_progress.progress.id === progressId,
        );

        // Guard: notification_progress paginado pode não conter este progress.
        if (updatedNotificationProgressIndex !== -1) {
          draft.management.notification_progress[
            updatedNotificationProgressIndex
          ].progress.task_event_comments = [
            ...state.management.notification_progress[updatedNotificationProgressIndex].progress
              .task_event_comments,
            result.data,
          ];
        }
        break;

      case ManagementTypes.CREATE_PROGRESS_COMMENT_FAILURE:
        draft.request.create_progress_comment = {
          ...INITIAL_STATE.request.create_progress_comment,
          error: true,
        };
        break;

      case ManagementTypes.CREATE_TASK_ATTACHMENT_REQUEST:
        draft.request.create_task_attachment = {
          ...INITIAL_STATE.request.create_task_attachment,
          loading: true,
        };

        break;

      case ManagementTypes.CREATE_TASK_ATTACHMENT_SUCCESS:
        draft.request.create_task_attachment = {
          ...INITIAL_STATE.request.create_task_attachment,
          loaded: true,
        };

        const newAttachmentTaskId = state.management.tasks.findIndex((task) => task.id === taskId);

        // Guard: task pode não estar nesta página paginada.
        if (newAttachmentTaskId !== -1) {
          draft.management.tasks[newAttachmentTaskId].bidding_attachments = [
            ...state.management.tasks[newAttachmentTaskId].bidding_attachments,
            result.data,
          ];
        }
        break;

      case ManagementTypes.CREATE_TASK_ATTACHMENT_FAILURE:
        draft.request.create_task_attachment = {
          ...INITIAL_STATE.request.create_task_attachment,
          error: true,
        };
        break;

      case ManagementTypes.CREATE_PROGRESS_ATTACHMENT_REQUEST:
        draft.request.create_progress_attachment = {
          ...INITIAL_STATE.request.create_progress_attachment,
          loading: true,
        };
        break;

      case ManagementTypes.CREATE_PROGRESS_ATTACHMENT_SUCCESS:
        draft.request.create_progress_attachment = {
          ...INITIAL_STATE.request.create_progress_attachment,
          loaded: true,
        };
        const newAttachmentNotificationProgressIndex =
          state.management.notification_progress.findIndex(
            (notification_progress) => notification_progress.progress.id === progressId,
          );

        // Guard: progress pode não estar nesta página paginada.
        if (newAttachmentNotificationProgressIndex !== -1) {
          draft.management.notification_progress[
            newAttachmentNotificationProgressIndex
          ].progress.bidding_attachments = [
            ...state.management.notification_progress[newAttachmentNotificationProgressIndex]
              .progress.bidding_attachments,
            result.data,
          ];
        }
        break;

      case ManagementTypes.CREATE_PROGRESS_ATTACHMENT_FAILURE:
        draft.request.create_progress_attachment = {
          ...INITIAL_STATE.request.create_progress_attachment,
          error: true,
        };
        break;

      case ManagementTypes.DELETE_TASK_ATTACHMENT_REQUEST:
        draft.request.delete_task_attachment = {
          ...INITIAL_STATE.request.delete_task_attachment,
          loading: true,
        };
        break;
      case ManagementTypes.DELETE_TASK_ATTACHMENT_SUCCESS:
        draft.request.delete_task_attachment = {
          ...INITIAL_STATE.request.delete_task_attachment,
          loaded: true,
        };

        const deletedAttachmentTaskId = state.management.tasks.findIndex(
          (task) => task.id === taskId,
        );

        // Guard: task pode não estar nesta página paginada.
        if (deletedAttachmentTaskId !== -1) {
          draft.management.tasks[deletedAttachmentTaskId].bidding_attachments =
            state.management.tasks[deletedAttachmentTaskId].bidding_attachments.filter(
              (attachment) => attachment.id !== biddingAttachmentId,
            );
        }

        break;
      case ManagementTypes.DELETE_TASK_ATTACHMENT_FAILURE:
        draft.request.delete_task_attachment = {
          ...INITIAL_STATE.request.delete_task_attachment,
          error: true,
        };
        break;

      case ManagementTypes.GET_NOTIFICATION_PROGRESS_REQUEST:
        draft.request.get_notification_progress = {
          ...INITIAL_STATE.request.get_notification_progress,
          loading: true,
        };
        break;

      case ManagementTypes.GET_NOTIFICATION_PROGRESS_SUCCESS:
        draft.request.get_notification_progress = {
          ...INITIAL_STATE.request.get_notification_progress,
          loaded: true,
        };

        draft.management.notification_progress = result.data.progress_notifications;
        draft.management.notification_progress_total_entries =
          result.data.total_entries ?? result.data.progress_notifications?.length ?? 0;

        break;

      case ManagementTypes.GET_NOTIFICATION_PROGRESS_FAILURE:
        draft.request.get_notification_progress = {
          ...INITIAL_STATE.request.get_notification_progress,
          error: true,
        };
        break;

      case ManagementTypes.UPDATE_NOTIFICATION_PROGRESS_REQUEST:
        draft.request.update_notification_progress = {
          ...INITIAL_STATE.request.update_notification_progress,
          loading: true,
        };
        break;

      case ManagementTypes.UPDATE_NOTIFICATION_PROGRESS_SUCCESS:
        draft.request.update_notification_progress = {
          ...INITIAL_STATE.request.update_notification_progress,
          loaded: true,
        };

        const updateNotificationProgressIndex = state.management.notification_progress.findIndex(
          (notification_progress) => notification_progress.id === notificationProgressId,
        );

        // Guard: notification pode não estar nesta página paginada.
        if (updateNotificationProgressIndex !== -1) {
          draft.management.notification_progress[updateNotificationProgressIndex].read = true;
        }
        break;

      case ManagementTypes.UPDATE_NOTIFICATION_PROGRESS_FAILURE:
        draft.request.update_notification_progress = {
          ...INITIAL_STATE.request.update_notification_progress,
          error: true,
        };
        break;

      case ManagementTypes.CREATE_PROGRESS_REQUEST:
        draft.request.create_progress = {
          ...INITIAL_STATE.request.create_progress,
          loading: true,
        };
        break;

      case ManagementTypes.CREATE_PROGRESS_SUCCESS:
        draft.request.create_progress = {
          ...INITIAL_STATE.request.create_progress,
          loaded: true,
        };

        draft.management.progress = [...draft.management.progress, result.data.progress];

        draft.management.notification_progress = [
          ...draft.management.notification_progress,
          {
            id: result.data.progress.id,
            user_id: result.data.progress.responsible_id,
            read: false,
            created_at: result.data.progress.created_at,
            task_id: result.data.progress.id,
            bidding_id: result.data.progress.bidding_id,
            notification_reason_id: 1,
            progress: result.data.progress,
            bidding: result.data.progress.bidding,
          },
        ];

        // draft.management.notification_progress = [...draft.management.notification_progress, result.data.progress];
        break;

      case ManagementTypes.CREATE_PROGRESS_FAILURE:
        draft.request.create_progress = {
          ...INITIAL_STATE.request.create_progress,
          error: true,
        };
        break;

      case ManagementTypes.UPDATE_PROGRESS_REQUEST:
        draft.request.update_progress = {
          ...INITIAL_STATE.request.update_progress,
          loading: true,
        };
        break;

      case ManagementTypes.UPDATE_PROGRESS_SUCCESS:
        draft.request.update_progress = {
          ...INITIAL_STATE.request.update_progress,
          loaded: true,
        };
        const progressList = [...state.management.progress];
        const progressIndex = state.management.progress.findIndex(
          (progress) => progress.id === result.data.progress.id,
        );
        // Guard: progress pode não estar nesta página paginada (atribuir em
        // índice -1 cria entrada negativa no array — comportamento errado).
        if (progressIndex !== -1) {
          progressList[progressIndex] = result.data.progress;
          draft.management.progress = progressList;
        }

        const notificationProgressList = [...state.management.notification_progress];
        const notificationProgressIndex = state.management.notification_progress.findIndex(
          (notification_progress) => notification_progress.task_id === result.data.progress.id,
        );
        if (notificationProgressIndex !== -1) {
          notificationProgressList[notificationProgressIndex] = {
            ...notificationProgressList[notificationProgressIndex],
            progress: result.data.progress,
          };
          draft.management.notification_progress = notificationProgressList;
        }
        break;

      case ManagementTypes.UPDATE_PROGRESS_FAILURE:
        draft.request.update_progress = {
          ...INITIAL_STATE.request.update_progress,
          error: true,
        };
        break;

      case ManagementTypes.DELETE_PROGRESS_REQUEST:
        draft.request.delete_progress = {
          ...INITIAL_STATE.request.delete_progress,
          loading: true,
        };
        break;

      case ManagementTypes.DELETE_PROGRESS_SUCCESS:
        draft.request.delete_progress = {
          ...INITIAL_STATE.request.delete_progress,
          loaded: true,
        };

        draft.management.progress = state.management.progress.filter(
          (progress) => progress.id !== progressId,
        );

        draft.management.notification_progress = state.management.notification_progress.filter(
          (notification_progress) => notification_progress.task_id !== progressId,
        );
        break;

      case ManagementTypes.DELETE_PROGRESS_FAILURE:
        draft.request.delete_progress = {
          ...INITIAL_STATE.request.delete_progress,
          error: true,
        };
        break;

      case ManagementTypes.GET_FINISHED_REQUEST:
        draft.request.finished = {
          ...INITIAL_STATE.request.finished,
          loading: true,
        };
        break;

      case ManagementTypes.GET_FINISHED_SUCCESS:
        draft.request.finished = {
          ...INITIAL_STATE.request.finished,
          loaded: true,
        };
        draft.management.finished = result.data.finished;
        draft.management.finished_total_entries =
          result.data.total_entries ?? result.data.finished?.length ?? 0;
        break;

      case ManagementTypes.GET_FINISHED_FAILURE:
        draft.request.finished = {
          ...INITIAL_STATE.request.finished,
          error: true,
        };
        break;

      case ManagementTypes.FINISH_MANAGED_REQUEST:
        draft.request.finish_managed = {
          ...INITIAL_STATE.request.finish_managed,
          loading: true,
        };
        break;

      case ManagementTypes.FINISH_MANAGED_SUCCESS:
        draft.request.finish_managed = {
          ...INITIAL_STATE.request.finish_managed,
          loaded: true,
        };

        const managed = state.management.managed.find((managed) => managed.id === biddingId);

        if (managed) {
          draft.management.finished = [
            ...state.management.finished,
            {
              ...managed,
              management_bidding_finished: {
                amount,
                created_at: moment().format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
                comments,
              },
              management_finished_status: finishedManagementStatus,
            },
          ];
        }

        draft.management.managed = state.management.managed.filter(
          (managed) => managed.id !== biddingId,
        );
        break;

      case ManagementTypes.FINISH_MANAGED_FAILURE:
        draft.request.finish_managed = {
          ...INITIAL_STATE.request.finish_managed,
          error: true,
        };
        break;

      case ManagementTypes.REACTIVATE_MANAGED_REQUEST:
        draft.request.reactivate_managed = {
          ...INITIAL_STATE.request.reactivate_managed,
          loading: true,
        };
        break;

      case ManagementTypes.REACTIVATE_MANAGED_SUCCESS:
        draft.request.reactivate_managed = {
          ...INITIAL_STATE.request.reactivate_managed,
          loaded: true,
        };

        draft.management.finished = state.management.finished.filter(
          (finished) => finished.id !== biddingId,
        );

        const reactivatedBidding = state.management.finished.find(
          (finished) => finished.id === biddingId,
        );

        if (reactivatedBidding)
          draft.management.managed = [
            ...state.management.managed,
            {
              id: reactivatedBidding.id,
              edital: reactivatedBidding.edital,
              datahora_prazo: reactivatedBidding.datahora_prazo,
              datahora_abertura: reactivatedBidding.datahora_abertura,
              datahora_retirada: reactivatedBidding.datahora_retirada,
              datahora_visita: reactivatedBidding.datahora_visita,
              datahora_documento: reactivatedBidding.datahora_documento,
              data_validade: reactivatedBidding.data_validade,
              objeto: reactivatedBidding.objeto,
              public_body: reactivatedBidding.public_body,
              total_managed_opened_tasks: reactivatedBidding.total_managed_opened_tasks,
              managed: reactivatedBidding.managed,
              managed_by_others: reactivatedBidding.managed_by_others,
              orgao_estado: reactivatedBidding.orgao_estado,
              orgao_cidade: reactivatedBidding.orgao_cidade,
              tipo_agrupamento_id: reactivatedBidding.tipo_agrupamento_id,
              managers: reactivatedBidding.managers,
            },
          ];

        break;

      case ManagementTypes.REACTIVATE_MANAGED_FAILURE:
        draft.request.reactivate_managed = {
          ...INITIAL_STATE.request.reactivate_managed,
          error: true,
        };
        break;

      case ManagementTypes.GET_MANAGEMENT_ATTACHMENTS_REQUEST:
        draft.request_management_attachments.get_management_attachments = {
          ...INITIAL_STATE.request_management_attachments.get_management_attachments,
          loading: true,
        };
        break;

      case ManagementTypes.GET_MANAGEMENT_ATTACHMENTS_SUCCESS:
        draft.request_management_attachments.get_management_attachments = {
          ...INITIAL_STATE.request_management_attachments.get_management_attachments,
          loaded: true,
        };

        draft.management_attachments[biddingId] = result?.data?.data
          ? result?.data?.data
          : result?.data;
        break;

      case ManagementTypes.GET_MANAGEMENT_ATTACHMENTS_FAILURE:
        draft.request_management_attachments.get_management_attachments = {
          ...INITIAL_STATE.request_management_attachments.get_management_attachments,
          error: true,
        };
        break;

      case ManagementTypes.CREATE_MANAGEMENT_ATTACHMENTS_REQUEST:
        draft.request_management_attachments.create_management_attachements[fileName] = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ManagementTypes.CREATE_MANAGEMENT_ATTACHMENTS_SUCCESS:
        draft.management_attachments[biddingId] = [
          ...state.management_attachments[biddingId],
          result.data,
        ];
        draft.request_management_attachments.create_management_attachements[fileName] = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ManagementTypes.CREATE_MANAGEMENT_ATTACHMENTS_FAILURE:
        draft.request_management_attachments.create_management_attachements[fileName] = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case ManagementTypes.DELETE_MANAGEMENT_ATTACHMENTS_REQUEST:
        draft.request_management_attachments.delete_management_attachements = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ManagementTypes.DELETE_MANAGEMENT_ATTACHMENTS_SUCCESS:
        draft.management_attachments[biddingId] = state.management_attachments[biddingId].filter(
          (attachment) => attachment.id !== biddingAttachmentId,
        );

        draft.request_management_attachments.delete_management_attachements = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ManagementTypes.DELETE_MANAGEMENT_ATTACHMENTS_FAILURE:
        draft.request_management_attachments.delete_management_attachements = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ManagementTypes.GET_MANAGEMENT_PREFERENCES_REQUEST:
        draft.request.get_management_preferences = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ManagementTypes.GET_MANAGEMENT_PREFERENCES_SUCCESS:
        draft.management_preferences = result?.data?.data ? result.data.data : result.data;

        draft.request.get_management_preferences = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ManagementTypes.GET_MANAGEMENT_PREFERENCES_FAILURE:
        draft.request.get_management_preferences = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case ManagementTypes.UPDATE_MANAGEMENT_PREFERENCES_REQUEST:
        draft.request.update_management_preferences = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ManagementTypes.UPDATE_MANAGEMENT_PREFERENCES_SUCCESS:
        draft.management_preferences = result?.data?.data ? result.data.data : result.data;

        draft.request.update_management_preferences = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ManagementTypes.UPDATE_MANAGEMENT_PREFERENCES_FAILURE:
        draft.request.update_management_preferences = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case ManagementTypes.GET_BIDDING_OVERVIEW_REQUEST:
        draft.request.get_bidding_overview = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ManagementTypes.GET_BIDDING_OVERVIEW_SUCCESS:
        draft.management.overview = result?.data;
        draft.management.overview_last_updated = Date.now();
        draft.management.overview_bidding_id = biddingId;
        draft.request.get_bidding_overview = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ManagementTypes.GET_BIDDING_OVERVIEW_FAILURE:
        draft.request.get_bidding_overview = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case ManagementTypes.GET_MANAGEMENT_MEMBERS_REQUEST:
        draft.request.get_management_members = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ManagementTypes.GET_MANAGEMENT_MEMBERS_SUCCESS:
        draft.management.members = {
          companyId,
          active: result?.data?.active || [],
          inactive: result?.data?.inactive || [],
        };
        draft.request.get_management_members = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ManagementTypes.GET_MANAGEMENT_MEMBERS_FAILURE:
        draft.request.get_management_members = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case ManagementTypes.UPDATE_CREATE_MANAGEMENT_ATTACHMENTS_STORE:
        draft.request_management_attachments.create_management_attachements =
          INITIAL_STATE.request_management_attachments.create_management_attachements;
        break;

      case ManagementTypes.UPDATE_STORE_FIELDS:
        if (!state.management.bidding_summary)
          draft.management.bidding_summary = INITIAL_STATE.management.bidding_summary;
        break;

      default:
        break;
    }
  });
};

export default reducer;
